module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/177-colombia-9a0862628ae1b2091f9e0aa73ce2c762.svg";